import React, { useMemo } from 'react'
import TraceableMappingFormV2 from './TraceableMappingFormV2'
import TraceableCredentialForm from './TraceableCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function TraceableConfigListing(props) {

    const columns = useMemo(() => [
        {
            title: "Environment",
            dataIndex: "environmentId",
            width: 130
        },
        {
            title: "Integration Type",
            dataIndex: "integrationType",
            width: 130
        },
        {
            title: "Service Name",
            dataIndex: "serviceName",
            width: 130,
            render: columnRenderArrayData,
        }
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={TraceableMappingFormV2}
            CredentialsForm={TraceableCredentialForm}
            extraColumns={columns}
        />
    )   
}